export default "__VITE_ASSET__5ea39545__"